var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", {
    directives: [
      {
        name: "loading",
        rawName: "v-loading.fullscreen.lock",
        value: _vm.canvasLoading,
        expression: "canvasLoading",
        modifiers: { fullscreen: true, lock: true }
      }
    ],
    attrs: {
      "element-loading-text": "加载中",
      "element-loading-spinner": "el-icon-loading",
      "element-loading-background": "rgba(255, 255, 255, 1)"
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-45feeb30", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-45feeb30","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/canvasShow/components/toast.vue
// module id = null
// module chunks = 